/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setting, users } from "../../../../api/Api";

export const getAllRole = createAsyncThunk("appUsers/getAllRole", async () => {
  try {
    return setting.getRoles();
  } catch (error) {
    console.error(error);
  }
});

export const getAllCountry = createAsyncThunk(
  "appUsers/getAllCountry",
  async () => {
    try {
      return setting.getCountry();
    } catch (error) {
      console.error(error);
    }
  }
);

export const addUser = createAsyncThunk(
  "appUsers/addUser",
  async ({ user, func }) => {
    try {
      return users.create(user, func);
    } catch (error) {
      console.error(error);
    }
  }
);

export const addUserAgentPageInfo = createAsyncThunk(
  "appUsers/addUser",
  async ({ user, func }) => {
    try {
      return users.createAgentbyAdmin(user, func);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllUser = createAsyncThunk(
  "appUsers/getAllUser",
  async (values) => {
    return users.getAll(values);
  }
);

export const getAllInActiveAgents = createAsyncThunk(
  "appUsers/getAllInActiveAgents",
  async (values) => {
    return users.getAllInActiveAgents(values);
  }
);

export const getAllDriver = createAsyncThunk(
  "appUsers/getAllDriver",
  async (values) => {
    return users.getAllDriver(values);
  }
);

export const getAllUserNoFilter = createAsyncThunk(
  "appUsers/getAllUserNoFilter",
  async () => {
    return users.getAllUserNoFilter();
  }
);

export const getAllSaleAgent = createAsyncThunk(
  "appUsers/getAllSaleAgent",
  async () => {
    return users.getAllSaleAgent();
  }
);

export const getAllSaleManager = createAsyncThunk(
  "appUsers/getAllSaleManager",
  async () => {
    return users.getAllSaleManager();
  }
);

export const getAllDeletedUser = createAsyncThunk(
  "appUsers/getAllDeletedUser",
  async (values) => {
    return users.getAllDeleted(values);
  }
);

export const getAllRecruiterUser = createAsyncThunk(
  "appUsers/getAllRecruiterUser",
  async (values) => {
    return users.getAllRecruiterUser(values);
  }
);

export const deleteUser = createAsyncThunk("appUser/deleteUser", async (id) => {
  return users.deleteItem(id);
});

export const deleteUserAgentPage = createAsyncThunk(
  "appUser/deleteUserAgentPage",
  async (id) => {
    return users.deleteUserAgentPage(id);
  }
);

export const unbanUser = createAsyncThunk("appUser/unbanUser", async (id) => {
  return users.unbanItem(id);
});

export const activeUser = createAsyncThunk(
  "appUser/activeUser",
  async (values) => {
    return users.activeUser(values);
  }
);

export const declineUser = createAsyncThunk(
  "appUser/declineUser",
  async (values) => {
    return users.declineUser(values);
  }
);

export const banUser = createAsyncThunk("appUser/banUser", async (values) => {
  return users.banUser(values);
});

export const editUserAdmin = createAsyncThunk(
  "appUser/editUserAdmin",
  async (values) => {
    return users.editByAdmin(values);
  }
);
export const editUserAdminAccount = createAsyncThunk(
  "appUser/editUserAdminAccount",
  async (values) => {
    return users.editUserAdminAccount(values);
  }
);
export const editUser = createAsyncThunk("appUser/ediUser", async (values) => {
  return users.edit(values);
});

export const getAllAgent = createAsyncThunk("appUser/getAllAgent", async () => {
  return users.getAllAgent();
});

export const getUserAgent = createAsyncThunk(
  "appUser/getUserAgent",
  async (id) => {
    return users.getUserAgent(id);
  }
);

export const postUserAgent = createAsyncThunk(
  "appUser/postUserAgent",
  async (values) => {
    return users.postUserAgent(values);
  }
);

export const postUserAgentAdmin = createAsyncThunk(
  "appUser/postUserAgent",
  async (values) => {
    return users.postUserAgentAdmin(values);
  }
);

export const editUserAgent = createAsyncThunk(
  "appUser/editUserAgent",
  async (data) => {
    return users.editUserAgent(data.values, data.id);
  }
);

export const getAllAgentAssistant = createAsyncThunk(
  "appUsers/getAllAgentAssistant",
  async (values) => {
    return users.getAllAgentAssistant(values);
  }
);

export const createAgentAssistant = createAsyncThunk(
  "appUsers/createAgentAssistant",
  async (values) => {
    return users.createAgentAssistant(values);
  }
);

export const deleteAgentAssistant = createAsyncThunk(
  "appUsers/deleteAgentAssistant",
  async (values) => {
    return users.deleteAgentAssistant(values);
  }
);

export const getUserReferral = createAsyncThunk(
  "appUsers/getUserReferral",
  async (id) => {
    try {
      return users.getAllUserReferral(id);
    } catch (error) {
      console.error(error);
    }
  }
);

export const appUsersSlice = createSlice({
  name: "appUsers",
  initialState: {
    users: [],
    userReferral: [],
    userReferralFetched: false,
    saleAgents: [],
    inActiveAgent: [],
    agents: [],
    driver: [],
    driverFetched: false,
    usersFetched: false,
    inActiveAgentFetched: false,
    usersNoFilter: [],
    saleManager: [],
    saleManagerFetched: false,
    usersNoFilterFetched: false,
    deletedUsers: [],
    recruiterUsers: [],
    data: [],
    roles: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    metaData: {},
    metaDataDeleted: {},
    country: [],
    countryFetched: false,
    rolesFetched: false,
    agentAssistant: [],
    agentAssistantFetched: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllRole.fulfilled, (state, action) => {
        state.roles = action.payload?.data?.data;
        state.rolesFetched = true;
      })
      .addCase(getAllCountry.fulfilled, (state, action) => {
        state.country = action.payload?.data?.data;
        state.countryFetched = true;
      })
      .addCase(getAllUser.fulfilled, (state, action) => {
        state.users = action.payload?.data?.data;
        state.metaData = action.payload.data.metaData;
        state.usersFetched = true;
        state.userReferralFetched = false;
      })

      .addCase(getAllInActiveAgents.fulfilled, (state, action) => {
        state.inActiveAgent = action.payload?.data?.data;
        state.metaData = action.payload.data.metaData;
        state.inActiveAgentFetched = true;
      })
      .addCase(getUserReferral.fulfilled, (state, action) => {
        state.userReferralFetched = true;
        state.userReferral = action.payload?.data?.data;
      })
      .addCase(getAllAgent.fulfilled, (state, action) => {
        state.agents = action.payload?.data?.data;
        state.metaDataAgents = action.payload.data.metaData;
      })
      .addCase(getAllDriver.fulfilled, (state, action) => {
        state.driver = action.payload?.data?.data;
        state.driverFetched = true;
      })
      .addCase(getAllAgentAssistant.fulfilled, (state, action) => {
        state.agentAssistant = action.payload?.data?.data;
        state.metaData = action.payload?.data?.metaData;
        state.agentAssistantFetched = true;
      })
      .addCase(getAllUserNoFilter.fulfilled, (state, action) => {
        state.usersNoFilter = action.payload?.data?.data;
        state.usersNoFilterFetched = true;
      })
      .addCase(getAllSaleManager.fulfilled, (state, action) => {
        state.saleManager = action.payload?.data?.data;
        state.saleManagerFetched = true;
      })
      .addCase(getAllDeletedUser.fulfilled, (state, action) => {
        state.deletedUsers = action.payload?.data?.data;
        state.metaDataDeleted = action.payload.data.metaData;
      })
      .addCase(getAllRecruiterUser.fulfilled, (state, action) => {
        state.recruiterUsers = action.payload?.data?.data;
      });
  },
});

export default appUsersSlice.reducer;
